import React from 'react';

import { PINGFED_APP_FIELDS } from '../../common/fields';
import TextInput from '../Controls/TextInput/TextInput';

import styles from './FederatedApps.module.css';
import { SUBCATEGORIES } from '../../common/categories';

const { NAME, IDENTIFIER } = PINGFED_APP_FIELDS;

const PingFedApp = ({ pingFedApp, changedFunc, disabled = false }) => {
    return (
        <div className={`${styles.federatedApp}${disabled ? ' ' + styles.disabled : ''}`}>
            <TextInput
                field={pingFedApp[NAME.ID]}
                color="grey"
                changed={changedFunc}
                disabled={disabled}
                featureLockId={SUBCATEGORIES.PING_FEDERATED_APPS.ID}
                featureLockIsTabId={true}
            />
            <TextInput
                field={pingFedApp[IDENTIFIER.ID]}
                color="grey"
                changed={changedFunc}
                disabled={disabled}
                featureLockId={SUBCATEGORIES.PING_FEDERATED_APPS.ID}
                featureLockIsTabId={true}
            />
        </div>
    );
};

export default React.memo(PingFedApp);
